var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5247_24458)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5247_24458",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3477 25.1133C26.3477 16.829 33.0634 10.1133 41.3477 10.1133C49.6319 10.1133 56.3477 16.829 56.3477 25.1133C56.3477 33.3976 49.6319 40.1133 41.3477 40.1133C33.0634 40.1133 26.3477 33.3976 26.3477 25.1133Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.3477 25.1133C26.3477 16.829 33.0634 10.1133 41.3477 10.1133C49.6319 10.1133 56.3477 16.829 56.3477 25.1133C56.3477 33.3976 49.6319 40.1133 41.3477 40.1133C33.0634 40.1133 26.3477 33.3976 26.3477 25.1133Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3533 18.9769V30.6133H40.8931V21.3121H40.8249L38.1602 22.9826V20.8008L41.0408 18.9769H43.3533Z",
    fill: "#183366"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7971 36.5772C47.4284 37.0443 47.037 37.4721 46.6255 37.8563C45.0937 39.2869 43.285 40.1133 41.3477 40.1133H46.3477C46.7497 40.1133 47.148 40.0975 47.542 40.0664C48.1913 40.0153 48.829 39.9228 49.4524 39.7916C50.3652 39.5995 51.2474 39.3244 52.0908 38.9745C52.091 38.3358 51.968 37.6865 51.7081 37.0598C51.2066 35.8504 50.2852 34.9423 49.183 34.4344C48.7694 35.2157 48.3049 35.9337 47.7971 36.5772ZM50.2999 31.8048C50.6092 33.3958 51.6849 34.8064 53.2942 35.4737C54.6138 36.021 56.0337 35.9611 57.2433 35.4227C58.0562 34.5639 58.7686 33.6091 59.3618 32.577C60.6252 30.3789 61.3477 27.8305 61.3477 25.1133C61.3477 22.3961 60.6252 19.8476 59.3618 17.6495C58.7686 16.6175 58.0562 15.6626 57.2433 14.8038C56.0337 14.2654 54.6138 14.2056 53.2942 14.7528C51.6849 15.4202 50.6092 16.8308 50.2999 18.4217C50.585 19.2782 50.8171 20.1813 50.9897 21.1213C51.223 22.3924 51.3477 23.731 51.3477 25.1133C51.3477 26.4956 51.223 27.8342 50.9897 29.1052C50.8171 30.0453 50.585 30.9484 50.2999 31.8048ZM52.0908 11.252C51.2474 10.9022 50.3652 10.6271 49.4524 10.435C48.829 10.3038 48.1913 10.2113 47.542 10.1601C47.148 10.1291 46.7497 10.1133 46.3477 10.1133H41.3477C43.285 10.1133 45.0937 10.9397 46.6255 12.3702C47.037 12.7545 47.4284 13.1823 47.7971 13.6494C48.3049 14.2928 48.7694 15.0108 49.183 15.7921C50.2852 15.2843 51.2066 14.3762 51.7081 13.1668C51.968 12.54 52.091 11.8907 52.0908 11.252Z",
    fill: "#183366",
    mask: "url(#path-1-inside-1_5247_24458)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5247_24458",
    x: 0.347656,
    y: 0.113281,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5247_24458"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5247_24458"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5247_24458",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1Icon);
export default __webpack_public_path__ + "static/media/Number1Icon.7bb1988777b37ae9fe8f71e4044f3e04.svg";
export { ForwardRef as ReactComponent };